import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import LinkToPayView from '../views/LinkToPay.vue'
Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/error',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "error" */ '../views/ErrorNotFound.vue')
  },
  {
    path: '/:id',
    component: LinkToPayView,
    children: [
      {
        path: '',
        name: 'LinkToPay',
        component: () => import(/* webpackChunkName: "LinkToPay" */ '../components/LinkToPay.vue')
      },
      {
        path: 'expired',
        name: 'Expired',
        component: () => import(/* webpackChunkName: "expired" */ '../components/ltp/Expired.vue')
      },
      {
        path: 'tinaba-pay',
        name: 'TinabaPay',
        component: () => import(/* webpackChunkName: "tinaba-pay" */ '../components/ltp/TinabaPay.vue')
      },
      {
        path: 'card',
        name: 'CardPay',
        component: () => import(/* webpackChunkName: "tinaba-pay" */ '../components/ltp/CardPayment.vue')
      },
      {
        path: 'success',
        name: 'Success',
        component: () => import(/* webpackChunkName: "success" */ '../components/ltp/Success.vue')
      },
      {
        path: 'error',
        name: 'Error',
        component: () => import(/* webpackChunkName: "success" */ '../components/ltp/Error.vue')
      },
      {
        path: 'processing',
        name: 'Processing',
        component: () => import(/* webpackChunkName: "success" */ '../components/ltp/Loading.vue')
      },
    ]
  },
  {
    path :'*',
    redirect: 'error'
  }
]

export const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
